export const stayPromotions = {
  title: "Promotions de séjour",
  description: "Offrez des remises spéciales à vos clients pour les séjours plus longs",
  newPromotion: "Nouvelle promotion",
  loading: "Chargement des promotions...",
  close: "Fermer",
  cancel: "Annuler",
  noLimit: "Aucune limite",

  status: {
    active: "Active",
    paused: "Suspendue",
  },

  card: {
    stay: "Séjour",
    discount: "Remise",
    validity: "Validité",
    edit: "Modifier",
    delete: "Supprimer",
  },

  nights: {
    range: "{min} - {max} nuits",
    min: "{min}+ nuits",
  },

  empty: {
    title: "Aucune promotion configurée",
    description: "Créez des promotions pour encourager les séjours plus longs et augmenter vos réservations",
    create: "Créer la première promotion",
  },

  form: {
    editTitle: "Modifier la promotion",
    createTitle: "Nouvelle promotion",
    nameLabel: "Nom de la promotion",
    namePlaceholder: "ex. remise 7 nuits, offre hebdomadaire",
    minNights: "Nuits minimum",
    maxNights: "Nuits maximum",
    optional: "(facultatif)",
    noLimitPlaceholder: "Aucune limite",
    discountType: "Type de remise",
    percentage: "Pourcentage",
    fixedAmount: "Montant fixe",
    discountValue: "Valeur de la remise",
    validFrom: "Valable à partir du",
    validTo: "Valable jusqu'au",
    activateNow: "Activer la promotion immédiatement",
    saving: "Enregistrement...",
    update: "Mettre à jour",
    create: "Créer la promotion",
  },

  invoice: {
    title: "Exemple d'économies",
    pricePerNight: "Prix par nuit",
    numberOfNights: "Nombre de nuits",
    subtotal: "Sous-total",
    discountApplied: "Remise appliquée",
    totalToPay: "Total à payer",
    guestSaves: "Le client économise {amount}",
  },

  statusModal: {
    activateTitle: "Activer la promotion",
    pauseTitle: "Suspendre la promotion",
    activateDescription: 'Voulez-vous activer la promotion "{name}" afin qu\'elle s\'applique aux nouvelles réservations ?',
    pauseDescription: 'Voulez-vous suspendre la promotion "{name}" ?',
    confirm: "Confirmer",
  },

  deleteModal: {
    title: "Supprimer la promotion",
    warningStrong: "Cette action est irréversible.",
    warningText: "Avant de supprimer, assurez-vous de ne plus avoir besoin de la promotion {name}.",
    confirmLabel: "Saisissez le nom exact pour confirmer :",
    confirmPlaceholder: "Saisissez le nom exact de la promotion",
    hint: "Collez ou saisissez le nom exactement tel qu'il apparaît ci-dessus pour activer le bouton de suppression.",
    deleting: "Suppression...",
    confirmDelete: "Supprimer définitivement",
  },

  toasts: {
    nameRequired: "Veuillez saisir un nom",
    minNightsWarning: "Le nombre de nuits minimum doit être de 1 ou plus",
    selectRatePlan: "Sélectionnez un plan tarifaire de base",
    updated: "Promotion mise à jour",
    created: "Promotion créée",
    saveFailed: "Impossible d'enregistrer",
    saveError: "Erreur lors de l'enregistrement",
    activated: "Promotion activée",
    pausedToast: "Promotion suspendue",
    updateFailed: "Impossible de mettre à jour",
    statusError: "Erreur lors du changement de statut",
    deleted: "Promotion supprimée",
    deleteFailed: "Impossible de supprimer",
    deleteError: "Erreur lors de la suppression",
  },
};
